import { render, staticRenderFns } from "./ShAIChat.md?vue&type=template&id=a707f7e6"
import script from "./ShAIChat.md?vue&type=script&lang=js"
export * from "./ShAIChat.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports